import { render, staticRenderFns } from "./BaseLoadingState.vue?vue&type=template&id=cffcf8ba&scoped=true&"
var script = {}
import style0 from "./BaseLoadingState.vue?vue&type=style&index=0&id=cffcf8ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffcf8ba",
  null
  
)

export default component.exports